import { useIntl } from "react-intl";
import * as yup from "yup";
import messages from "./messages.i18n";
import { PeekInput } from "@piiqtechnologies/ui-components";
import { PROVIDERS, ProvidersSelector } from "./utils";
import { AiDiscoverabilityAddressInput } from "./AiDiscoverabilityAddressInput";
export const AiDiscoverabilityFormInitialValues = {
    communityName: "",
    communityAddress: null,
    llmProviders: PROVIDERS.map((provider) => {
        var _a, _b;
        return ({
            provider: provider.id,
            model: (_b = (_a = provider.models[0]) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : "",
        });
    }).filter((item) => Boolean(item.model)),
};
export const AiDiscoverabilityFormValidationSchema = () => {
    const intl = useIntl();
    const getAddressValue = (value) => {
        if (!value)
            return "";
        if (typeof value === "string")
            return value;
        return value.name || value.description || "";
    };
    return yup.object().test(function (values) {
        var _a;
        const { communityName, communityAddress } = values;
        if (!(communityName === null || communityName === void 0 ? void 0 : communityName.trim()) && !((_a = getAddressValue(communityAddress)) === null || _a === void 0 ? void 0 : _a.trim())) {
            return this.createError({
                path: "communityName",
                message: intl.formatMessage(messages.aiDiscoverabilityValidationAtLeastOneField),
            });
        }
        return true;
    });
};
export const getAiDiscoverabilityFormFields = (mapAPiloaded) => {
    const intl = useIntl();
    return {
        prospect: [
            {
                id: "receiverEmail",
                label: intl.formatMessage(messages.aiDiscoverabilityReceieverEmailLabel),
                placeholder: intl.formatMessage(messages.aiDiscoverabilityReceieverEmailPlaceholder),
                required: false,
                columns: 12,
                fullWidth: true,
                component: PeekInput,
            },
        ],
        community: [
            {
                id: "communityName",
                label: intl.formatMessage(messages.aiDiscoverabilityCommunityNameLabel),
                placeholder: intl.formatMessage(messages.aiDiscoverabilityCommunityNamePlaceholder),
                required: true,
                columns: 12,
                fullWidth: true,
                component: PeekInput,
            },
            {
                id: "communityAddress",
                label: intl.formatMessage(messages.aiDiscoverabilityCommunityAddressLabel),
                placeholder: intl.formatMessage(messages.aiDiscoverabilityCommunityAddressPlaceholder),
                required: true,
                columns: 12,
                fullWidth: true,
                component: AiDiscoverabilityAddressInput,
                mapAPiloaded,
            },
        ],
        llmProviders: [
            {
                id: "llmProviders",
                label: intl.formatMessage(messages.aiDiscoverabilityAgentModelLabel),
                placeholder: "",
                required: false,
                columns: 12,
                fullWidth: true,
                component: ProvidersSelector,
            },
        ],
    };
};
